import { render } from "./Payments.vue?vue&type=template&id=e334503a&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=e334503a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e334503a"]])

export default __exports__